import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "../styles/grid-styles.css";
import FilesComponent from "./document_library/DocLibraryComponent";
import InternalUserRoute from "../util/internal_user_route";

function DocumentLibrary() {
  return (
    <InternalUserRoute>
      <FilesComponent/>
    </InternalUserRoute>
  )
}

export default DocumentLibrary